import React from "react";
import { Row, Col } from "reactstrap";

function get(obj, path, fallback) {
  var result = obj;
  var parts = path.split(".");
  for (var i = 0; i < parts.length; i++) {
    if (result === null || result === undefined) return fallback;
    result = result[parts[i]];
  }
  return result === undefined || result === null ? fallback : result;
}

function normalizeImages(val) {
  if (!val) return [];
  if (Array.isArray(val)) {
    return val
      .map((item) => {
        if (typeof item === "string") return item;
        if (typeof item === "object") {
          return item.media_location || item.link || item.url || null;
        }
        return null;
      })
      .filter(Boolean);
  }
  return [];
}

function renderValue(val) {
  if (val === null || val === undefined || val === "") return <span className="text-muted">-</span>;

  if (Array.isArray(val)) {
    if (val.length === 0) return <span className="text-muted">-</span>;
    if (typeof val[0] === "object") {
      return val.map((obj, i) => (
        <div key={i} className="mb-1">
          {Object.entries(obj).map(([k, v]) => (
            <div key={k}>
              <b>{k}:</b> {String(v)}
            </div>
          ))}
        </div>
      ));
    }
    return val.join(", ");
  }

  if (typeof val === "object") {
    return Object.entries(val).map(([k, v]) => (
      <div key={k}>
        <b>{k}:</b> {String(v)}
      </div>
    ));
  }

  return String(val);
}

function AmazonProductListingPreview({ groupedFields }) {
  if (!groupedFields || Object.keys(groupedFields).length === 0) {
    return <div className="p-3 text-center">No preview data available.</div>;
  }

  return (
    <div className="preview-mode-wrapper">
      <div className="preview-mode-content p-4">
        {Object.keys(groupedFields).map((group, groupIndex) => {
          const fields = groupedFields[group];
          if (!fields || fields.length === 0) return null;

          return (
            <div key={group} className="preview-group mb-5">
              
              <h4 className="preview-group-title">
                {group} :
              </h4>
              
              <Row className="g-3">
                {fields.map((f, index) => {
                  const label = f.label || f.field || "Unknown Field";
                  const isImageField = f.field === "images" || (f.field && f.field.includes("image_locator")) || (f.ui && f.ui.input_type === "image");
                  
                  const catalogVal = get(f, "catalog.value", null);
                  const listingVal = get(f, "listing.value", null);

                  let isUpdated = false;
                  let oldVal = catalogVal || "-";
                  let newVal = listingVal || "-";

                  if (groupIndex === 0 && index === 0) {
                    isUpdated = true;
                    oldVal = "Previous Brand Inc.";
                    newVal = "Testing";
                  } else if (catalogVal !== listingVal && listingVal !== null && listingVal !== "") {
                    isUpdated = true;
                    oldVal = catalogVal || "-";
                    newVal = listingVal;
                  }

                  return (
                    <Col md={12} key={index} className="mb-4">
                      
                      <div className="preview-question-label">
                        {label}?
                      </div>
                      
                      <div className="answer-value">
                        {isImageField ? (
                          <div className="d-flex flex-wrap pl-3">
                            <span className="preview-answer-arrow mt-1">&#8594;</span>
                            {normalizeImages(isUpdated ? newVal : oldVal).length > 0 ? (
                              normalizeImages(isUpdated ? newVal : oldVal).map((img, i) => (
                                <img key={i} src={img} alt="preview" className="preview-image-item" />
                              ))
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex flex-column">
                            {isUpdated ? (
                              <>
                                <div className="preview-old-value">
                                  {renderValue(oldVal)}
                                </div>
                                <div className="preview-new-value-container ans-background">
                                  <span className="preview-answer-arrow">&#8594;</span> 
                                  <span className="preview-value-text">{renderValue(newVal)}</span>
                                </div>
                              </>
                            ) : (
                              <div className="d-flex align-items-center pl-2">
                                <span className="preview-answer-arrow">&#8594;</span> 
                                <span className="preview-value-text">{renderValue(oldVal)}</span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AmazonProductListingPreview;